/**
 * /me/travel/request — Session 3d PR 24.
 * Owning agent: Khidmat. Detail-card-style page (NOT a list).
 */

import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { ErrorPanel, Loading } from "../components/Loading";
import { session3dApi } from "../lib/session3d-api";
import {
  MeActionsRow,
  MeEmployeeRequiredGate,
  Session3dMeShell,
  useCurrentEmployeeId,
} from "./_session3dShell";

export function MyRequestTravelPage() {
  const { t } = useTranslation();
  const employeeId = useCurrentEmployeeId();

  const query = useQuery({
    queryKey: ["s3d-request-travel", employeeId],
    queryFn: () => session3dApi.listMyTrips(employeeId),
    enabled: !!employeeId,
  });

  const data = query.data;

  return (
    <MeEmployeeRequiredGate>
      <Session3dMeShell
        title={t("me.request-travel.title", "Request New Trip")}
        subtitle={t("me.request-travel.subtitle", "Submit travel request with destination + dates + purpose.")}
        briefContext={{
          total: 1,
          attention: 0,
          critical: 0,
          top_kind: t("me.request-travel.title", "Request New Trip"),
          window_label: t("me.request-travel.window", "your travel category"),
        }}
        actionsRow={
          <MeActionsRow
            khidmatPrefill={t("me.request-travel.ask_khidmat", "Help me request a business trip.")}
          />
        }
      >
        {query.isLoading && <Loading />}
        {query.isError && <ErrorPanel message={(query.error as Error).message} />}
        {data && (
          <div className="rounded-2xl border border-border-subtle bg-white p-4 text-sm">
            <p className="text-xs text-text-tertiary">
              {t(
                "me.request-travel.detail_note",
                "Form fields: destination (M3X.TRAVEL matrix) · departure + return dates · purpose · multi-segment booking (Flight/Hotel/Car). Khidmat suggests flights (READ-ONLY · displays · doesn't book).",
              )}
            </p>
            <pre className="mt-3 overflow-x-auto rounded bg-surface-sunken p-3 font-mono text-[10px] text-text-secondary">
{JSON.stringify(data, null, 2)}
            </pre>
          </div>
        )}
      </Session3dMeShell>
    </MeEmployeeRequiredGate>
  );
}
